'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Children, isValidElement, useRef, type PropsWithChildren } from 'react'
import type { DisclosureGroupProps, Key } from 'react-aria-components'
import { DisclosureGroup } from 'react-aria-components'

export type AccordionProps = UiComponentProps &
  PropsWithChildren &
  DisclosureGroupProps & {
    /** Whether the first item is initially open or not  */
    opensFirst?: boolean
  }

function getFirstChildId(children: PropsWithChildren['children']) {
  const firstChild = Children.toArray(children)[0]

  if (!isValidElement<{ id?: Key }>(firstChild)) {
    return undefined
  }

  return firstChild.props.id
}

export function Accordion({ opensFirst = false, children, className, ...props }: AccordionProps) {
  const id = getFirstChildId(children)
  const defaultExpanded = useRef<Set<Key>>(id ? new Set([id]) : new Set())

  return (
    <DisclosureGroup
      className={twMerge('flex min-w-0 flex-col', className)}
      data-testid="accordion"
      {...props}
      {...(opensFirst ? { defaultExpandedKeys: defaultExpanded.current } : {})}
    >
      {children}
    </DisclosureGroup>
  )
}
